import { thousandSeparatorType } from "./number-thousand-separator-utils";

export const isStringConvertibleToNumber = (inputString: string) => {
  if (
    inputString.split("-").length > 2 ||
    (inputString.includes("-") && inputString.split("-").length === 2 && inputString[0] !== "-")
  ) {
    return false;
  }

  // To ignore comma, dot, space, single quote, minus and plus
  const regex = /[.,' \-+'"]/g;

  const convertedToLocale = new Intl.NumberFormat("it-CH").format(1000.25);
  // Exctract apostrophe to remove it
  const thousandsSeparator = convertedToLocale[1];

  //Remove the specified characters from the string
  const resultString = inputString.replace(regex, "").split(thousandsSeparator).join("");

  return !Number.isNaN(Number(resultString));
};

export const canBeConvertedToNumber = (
  userPreferences: any,
  value: string,
  ignoreFirstZeroAndLastCharAsDecimalSeparator: boolean = false
) => {
  const pattern = /^[0-9]$/;

  const valueWithoutMinus = value
    .split("")
    .filter((char) => char !== "-")
    .join("");

  const lastChar = valueWithoutMinus[valueWithoutMinus.length - 1];

  if (!userPreferences) {
    const userLocale = thousandSeparatorType || navigator.language;

    const convertedToLocale = new Intl.NumberFormat(userLocale).format(1000.25);
    const thousandsSeparator = convertedToLocale[1];
    const decimalSeparator = convertedToLocale[convertedToLocale.length - 3];

    const splitedNumberToConvertByDecimalSeparator = valueWithoutMinus.split(decimalSeparator);

    const integerPart = splitedNumberToConvertByDecimalSeparator[0].split(thousandsSeparator).join("");

    if (
      !!splitedNumberToConvertByDecimalSeparator[0] &&
      splitedNumberToConvertByDecimalSeparator[0][0] === thousandsSeparator &&
      // !pattern.test(lastChar) &&
      !ignoreFirstZeroAndLastCharAsDecimalSeparator
    ) {
      return "cutFirstChar";
    }

    return ignoreFirstZeroAndLastCharAsDecimalSeparator
      ? true
      : pattern.test(lastChar) &&
          Number.isInteger(Number(integerPart)) &&
          !!integerPart &&
          integerPart[0] !== "0" &&
          integerPart[0] !== thousandsSeparator;
  } else {
    //  extract thousands and decimals separator from user preferences when BE will be done
    const thousandsSeparator = "'";
    const decimalSeparator = ".";

    const splitedNumberToConvertByDecimalSeparator = valueWithoutMinus.split(decimalSeparator);

    const integerPart = splitedNumberToConvertByDecimalSeparator[0].split(thousandsSeparator).join("");

    if (
      !!splitedNumberToConvertByDecimalSeparator[0] &&
      splitedNumberToConvertByDecimalSeparator[0][0] === thousandsSeparator &&
      // !pattern.test(lastChar) &&
      !ignoreFirstZeroAndLastCharAsDecimalSeparator
    ) {
      return "cutFirstChar";
    }

    return ignoreFirstZeroAndLastCharAsDecimalSeparator
      ? true
      : pattern.test(lastChar) &&
          Number.isInteger(Number(integerPart)) &&
          !!integerPart &&
          integerPart[0] !== "0" &&
          integerPart[0] !== thousandsSeparator;
  }
};

const useCheckIfCanBeConvertedToNumber = (): Function => {
  // Extract user preferences from store and pass to "canBeConvertedToNumber"

  return (value: string, ignoreFirstZero?: boolean) => canBeConvertedToNumber(null, value, ignoreFirstZero);
};

export default useCheckIfCanBeConvertedToNumber;
